import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/apiMethods";

export type TBusinessInfo = {
  id: number;
  rcNumber: string;
  businessName: string;
  registrationDate: string;
  phoneNo: string;
  email: string;
  state: string;
  city: string;
  address: string;
  customerSubTypeId: number;
  customerSubType: string;
  ratingId: number;
  rating: string;
  isDisabled: boolean;
  note: string;
  datetimeCreated: string;
  createdByUserId: number;
  createdByUserName: string;
  datetimeUpdated: string;
  isCreated?: boolean;
  statusId: number;
};

type TResponse = {
  data: TBusinessInfo[];
  totalCount: number;
};

export type TQuery = {
  Page: number;
  PageSize: number;
  search_value?: string;
};

const getProspectivePrincipals = async ({
  Page,
  PageSize,
  search_value,
}: TQuery) => {
  let query = `?Page=${Page}&PageSize=${PageSize}`;
  if (search_value) {
    query = `${query}&searchValue=${search_value}`;
  }

  const data = await getData(`${ajaxEndpoints.PROSPECT_PRINCIPALS}${query}`);

  return data;
};

export default function useProspectivePrincipals({
  Page,
  PageSize,
  search_value,
}: TQuery) {
  return useQuery<TResponse>(
    [
      {
        Page,
        PageSize,
        search_value,
      },
      "getProspectivePrincipals",
    ],
    getProspectivePrincipals,
    {
      refetchOnWindowFocus: false,
    },
  );
}
